import { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Printer } from "lucide-react";
import { toast } from "sonner";

const p = (v) => (v == null ? "—" : `${v} %`);

function Kpi({ label, value, testid }) {
  return (
    <div className="ek-card p-4" data-testid={testid}>
      <div className="text-xs text-[#5C736A]">{label}</div>
      <div className="text-xl sm:text-2xl font-bold mt-1" style={{ fontFamily: "Outfit" }}>{value}</div>
    </div>
  );
}

export default function AssiduiteStats({ classId }) {
  const today = new Date().toISOString().slice(0, 10);
  const [start, setStart] = useState(new Date(Date.now() - 29 * 86400000).toISOString().slice(0, 10));
  const [end, setEnd] = useState(today);
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!classId) return;
    setD(null);
    api.get("/assiduite/stats", { params: { class_id: classId, start, end } }).then(({ data }) => setD(data)).catch((e) => toast.error(formatError(e)));
  }, [classId, start, end]);

  return (
    <div className="space-y-4" data-testid="assiduite-stats">
      <div className="flex flex-wrap items-center gap-2 print:hidden">
        <span className="text-sm text-[#5C736A]">Du</span><Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="w-44" data-testid="stats-start" />
        <span className="text-sm text-[#5C736A]">au</span><Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="w-44" data-testid="stats-end" />
        <Button variant="outline" className="ml-auto" onClick={() => window.print()} data-testid="stats-print"><Printer className="w-4 h-4 mr-1" /> Imprimer le rapport</Button>
      </div>
      {d && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <Kpi label="Jours de classe" value={d.jours_classe} testid="st-jours" />
            <Kpi label="Demi-journées possibles" value={d.demi_journees_possibles} testid="st-possibles" />
            <Kpi label="Présences" value={d.presences} testid="st-presences" />
            <Kpi label="Absences" value={d.absences} testid="st-absences" />
            <Kpi label="Taux de présence" value={p(d.taux_presence)} testid="st-taux-presence" />
            <Kpi label="Taux d'absence" value={p(d.taux_absence)} testid="st-taux-absence" />
            <Kpi label="Retards" value={d.retards} testid="st-retards" />
            <Kpi label="Heures réalisées / prévues" value={`${d.heures_realisees} / ${d.heures_dues} h (${p(d.taux_heures)})`} testid="st-heures" />
          </div>
          <p className="text-xs text-[#5C736A]">Calcul : 2 demi-journées par jour ouvré (lundi au vendredi) × nombre d&apos;élèves. Taux de présence = (possibles − absences) / possibles.</p>
          <div className="ek-card p-0 ek-table-wrap">
            <Table>
              <TableHeader><TableRow><TableHead>Élève</TableHead><TableHead>Possibles</TableHead><TableHead>Présences</TableHead><TableHead>Absences</TableHead><TableHead className="hidden sm:table-cell">Justifiées</TableHead><TableHead>Retards</TableHead><TableHead>Présence</TableHead></TableRow></TableHeader>
              <TableBody>{d.eleves.map((s) => (
                <TableRow key={s.id} data-testid="stats-student-row">
                  <TableCell><span className="font-normal">{s.prenom}</span> <span className="font-semibold">{s.nom}</span></TableCell>
                  <TableCell>{s.possibles}</TableCell><TableCell>{s.presences}</TableCell><TableCell className={s.absences ? "text-red-600 font-semibold" : ""}>{s.absences}</TableCell>
                  <TableCell className="hidden sm:table-cell">{s.justifiees}</TableCell><TableCell>{s.retards}</TableCell>
                  <TableCell className={s.taux_presence != null && s.taux_presence < 90 ? "text-red-600 font-semibold" : "text-[#1F7A63] font-semibold"}>{p(s.taux_presence)}</TableCell>
                </TableRow>
              ))}</TableBody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
}
